<div
  (click)="closeOffCanvas()"
  [@fade]="opened ? 'in' : 'out'"
  class="go-off-canvas-backdrop"
  tabindex="-1">
</div>

<div
  [@offCanvas]="{value: opened ? 'slideIn' : 'slideOut', params: {width: getOffCanvasWidth()}}"
  class="go-off-canvas"
  [ngClass]="{'go-off-canvas--large': size === 'large'}"
  role="dialog">

  <div class="go-off-canvas__header">
    <h3 *ngIf="header" class="go-heading-3 go-heading--no-margin go-off-canvas__title">
      {{ header }}
    </h3>
    <ng-container [ngSwitch]="size">
      <go-icon-button *ngSwitchCase="'small'" buttonSize="medium" buttonIcon="close"
                      (handleClick)="closeOffCanvas()">
      </go-icon-button>
      <ng-container *ngSwitchCase="'large'" goPortalTarget="offCanvasHeader"></ng-container>
    </ng-container>
  </div>

  <div class="go-off-canvas__content">
    <ng-template go-off-canvas-host></ng-template>
  </div>

  <div goPortalTarget="offCanvasSubmitButton"></div>
</div>
